import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rr_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token on every request when present
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Auto clear token on 401 so admin routes redirect to login
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      clearToken();
    }
    return Promise.reject(error);
  }
);

export const publicApi = {
  get: () => api.get("/public").then((r) => r.data),
};

export const authApi = {
  login: (password) => api.post("/admin/login", { password }).then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
};

export const adminApi = {
  listSongs: () => api.get("/admin/songs").then((r) => r.data),
  createSong: (payload) => api.post("/admin/songs", payload).then((r) => r.data),
  updateSong: (id, payload) => api.put(`/admin/songs/${id}`, payload).then((r) => r.data),
  deleteSong: (id) => api.delete(`/admin/songs/${id}`).then((r) => r.data),
  reorderSongs: (ordered_ids) => api.post("/admin/songs/reorder", { ordered_ids }).then((r) => r.data),
  importFolder: (folder_link) => api.post("/admin/import-folder", { folder_link }).then((r) => r.data),
  wipeSongs: (password) => api.delete("/admin/songs/wipe", { data: { password } }).then((r) => r.data),
  getSettings: () => api.get("/admin/settings").then((r) => r.data),
  updateSettings: (payload) => api.put("/admin/settings", payload).then((r) => r.data),
};
